import React from "react";
import { bool } from "prop-types";
import cx from "classnames";

const propTypes = {
  isLoading: bool,
};

const Loading = props => {
  const { isLoading } = props;

  return (
    <div
      className={cx("loading", {
        "loading--loading": isLoading,
      })}
    >
      <div className="loading__spinner">
        <div className="loading__line"></div>
        <div className="loading__line"></div>
        <div className="loading__line"></div>
      </div>
    </div>
  );
};

Loading.propTypes = propTypes;
export default Loading;
